<template>
  <div>
    <div class="top-center">
      <div class="top-center-inner">
        <div class="top-center-title">
          <i class="el-icon-user"></i>
          服务企业
        </div>
        <div class="top-center-value"> {{ companyCount }}家</div>
      </div>
      <div class="top-center-inner">
        <div class="top-center-title">
          <i class="el-icon-menu"></i>
          危废种类
        </div>
        <div class="top-center-value"> {{ categoryCount }}种</div>
      </div>
      <div class="top-center-inner">
        <div class="top-center-title">
          <i class="el-icon-s-data"></i>
          危废重量
        </div>
        <div class="top-center-value"> {{ dangerWasterWeight }}吨</div>
      </div>
    </div>
    <div class="map-container">
      <category-map></category-map>
    </div>

  </div>
</template>

<script>
import categoryMap from "./map.vue"
export default {
  components: { categoryMap },
  data() {
    return {
      companyCount: "0",
      categoryCount: "0",
      dangerWasterWeight: "0"
    }
  },
  methods: {
    formatNumber(num) {

      const number = Number(num);

      // 使用Intl.NumberFormat对象格式化数字
      const formatter = new Intl.NumberFormat('en-US');
      return formatter.format(number);

    },
    getCount() {
      const url = this.$api.cockpit.getCount;
      this.$axios.get(url, null, false).then((res) => {
        if (res.data.code == 0) {
          const { companyCount, categoryCount, dangerWasterWeight } = res.data.data;
          this.companyCount = this.formatNumber(companyCount);
          this.categoryCount = this.formatNumber(categoryCount);
          this.dangerWasterWeight = this.formatNumber(dangerWasterWeight);
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    }
  },
  mounted() {
    this.getCount();
  }
}
</script>

<style lang="scss" scoped>
.map-container {
  width: 100%;
  height: calc(100% - 91px);
  padding: 0 10px;
}

.top-center-inner {
  .top-center-title {
    color: #fff;
    margin-bottom: 5px;
  }

  .top-center-value {
    color: rgb(71, 247, 253);
    font-weight: bold;
    font-size: 24px;
    width: 150px;
    height: 50px;
    line-height: 50px;
    padding-left: 16px;
    background: linear-gradient(to right, #20417f, #111944);
    border-radius: 5px;
  }
}


.top-center {
  display: flex;
  justify-content: space-around;
  margin-bottom: 15px;
}
</style>